<!--==================================
=            APEXCHARTPIE            =
===================================-->

<template>

   <div id="recentorders"></div>
</template>


<script>
export default{
  name:'apex-chart-pie',
    mounted() {
       
      var options = {
        chart: {
          height: 305,
          type: 'radialBar',
          offsetX: 0,
          offsetY: 10,
        },     tooltip: {
          theme: "dark"
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            size: 120,
            imageWidth: 50,
            imageHeight: 50,
            track: {
              strokeWidth: "80%",
            },
            dropShadow: {
              enabled: false,
              top: 0,
              left: 0,
              bottom: 0,
              blur: 3,
              opacity: 0.5
            },
            dataLabels: {
              name: {
                fontSize: '16px',
                color: undefined,
                offsetY: 30,
              },
              hollow: {
                size: "60%"
              },
              value: {
                offsetY: -10,
                fontSize: '22px',
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                }
              }
            }
          }
        },
        colors:['#004c4c'],
        fill: {
          type: "gradient",
          gradient: {
            shade: "gradient",
            type: "horizontal",
            shadeIntensity: .5,
            gradientToColors: ['#004c4c'],
            inverseColors: !0,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          dashArray: 4
        },
        series: [83],
        labels: [""]
      };

      var chart = new ApexCharts(document.querySelector("#recentorders"), options);
      chart.render(); 
    },
}
</script>

<!--====  End of APEXCHARTPIE  ====-->
